var render = function render(){var _vm=this,_c=_vm._self._c;return _c('EUIPageLayout',{attrs:{"breadcrumbs":_vm.breadcrumbs,"title":`Application #${_vm.approval.referenceNumber}`,"loading":_vm.approvalLoading},scopedSlots:_vm._u([{key:"body",fn:function(){return [(!_vm.approvalLoading)?_c(_vm.approvalType,{tag:"component"}):_vm._e()]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }